import React, { useState } from 'react';
import MainCalculatorsList from '../MainCalculators';
import SharedHelmet from '../Helmet';
import RelatedLinks from '../RelatedLinks';
import { CalculatorsType } from '../ConstantsEN';
import { FirstAds, SecondAds , MobileUnderCalAds } from "../../Ads";
const TITLE = 'Cylinder Circumference Calculator - Calculate Cylinder Circumference Based on Diameter and Height';
const DESCRIPTION = 'The Cylinder Circumference Calculator calculates the circumference of a cylinder based on its diameter and height.';
const KEYWORDS = 'Cylinder circumference, Calculate cylinder circumference, Cylinder calculator';
const OG_URL = 'https://do-calculate.com/calculator/en/cylinder-circumference';
function Calculator() {
    const [diameter, setDiameter] = useState('');
    const [height, setHeight] = useState('');
    const [circumference, setCircumference] = useState('');
    const [error, setError] = useState('');
    const [solutionSteps, setSolutionSteps] = useState([]);
    const handleCalculate = () => {
        if (!diameter || !height) {
            setError('Please enter the diameter and height correctly');
            setCircumference('');
            return;
        }
        const generateSolutionSteps = (diameter, height, circumference) => {
            const steps = [];
            steps.push(`Step 1: Enter the diameter (${diameter}) and height (${height})`);
            steps.push(`Step 2: Calculate the cylinder circumference using the formula: 2 × π × diameter = 2 × π × ${diameter} = ${circumference}`);
            steps.push(`Step 3: Cylinder circumference calculated successfully`);
            return steps;
        };
        const diameterValue = parseFloat(diameter);
        const heightValue = parseFloat(height);
        if (isNaN(diameterValue) || isNaN(heightValue) || diameterValue <= 0 || heightValue <= 0) {
            setError('Please enter valid and positive values for diameter and height');
            setCircumference('');
            return;
        }
        const circumferenceValue = 2 * Math.PI * diameterValue;
        setCircumference(circumferenceValue.toFixed(2));
        const steps = generateSolutionSteps(diameterValue, heightValue, circumferenceValue.toFixed(2));
        setSolutionSteps(steps);
        setError('');
    };
    return (
        <div>
            <SharedHelmet TITLE={TITLE} DESCRIPTION={DESCRIPTION} KEYWORDS={KEYWORDS} OG_URL={OG_URL}  />
            <div className="row">
                <div className="col-12 col-md-8">
                    <FirstAds />
                </div>
            </div>
            <div className="row">
                <div className="col-12 col-md-8">
                    <br />
                    <div className="bg-success text-white text-center" style={{ height: '40px' }}>
                        <h1 style={{ fontSize: '17px' }}>{TITLE}</h1>
                    </div>
                            <div className="border border-light">
                                <div className="row">
                                    <div>
                                        <h2 style={{ fontSize: '18px' }}>How to Calculate Cylinder Circumference</h2>
                                        <p>
                                            To calculate the circumference of a cylinder, you need to input the diameter and height.
                                            Then, the cylinder's circumference will be calculated simply using the following formula:
                                        </p>
                                        <p>
                                            Cylinder Circumference = 2 × π × Diameter
                                        </p>
                                        <p>
                                            You can use this calculator to calculate the cylinder's circumference based on the entered numbers.
                                        </p>
                                        <hr />
                                    </div>
                                </div>
                                 <MobileUnderCalAds/>
                                <div className="row">
                                    <div className="col-sm-12 col-md-7 calculatorStyle">
                                        <div className='p-3 mb-2 bg-success text-white'>
                                            <h2 style={{ fontSize: '16px' }}>{TITLE} </h2>
                                        </div>
                                        <hr />
                                        <div dir="ltr">
                                            <div>
                                                <div className="form-group d-flex align-items-center">
                                                    <b>
                                                        <label className="form-label ms-2">Diameter</label>
                                                    </b>
                                                    <input
                                                        type="number"
                                                        placeholder="Diameter"
                                                        value={diameter}
                                                        onChange={(e) => setDiameter(e.target.value)}
                                                        className="form-control"
                                                        style={{ width: '150px' }}
                                                    />
                                                </div>
                                                <br />
                                                <div className="form-group d-flex align-items-center">
                                                    <b>
                                                        <label htmlFor='height' className="form-label ms-2">Height</label>
                                                    </b>
                                                    <input
                                                        type="number"
                                                        placeholder="Height"
                                                        value={height}
                                                        onChange={(e) => setHeight(e.target.value)}
                                                        className="form-control"
                                                        style={{ width: '150px' }}
                                                    />
                                                </div>
                                                <br />
                                                <button
                                                    className="btn btn-success"
                                                    style={{ fontSize: '20px' }}
                                                    onClick={handleCalculate}
                                                >
                                                    Calculate Cylinder Circumference
                                                </button>
                                            </div>
                                            <br />
                                            <div>
                                                {error !== '' ? (
                                                    <p className='p-3 mb-2 bg-warning text-white'>Error: {error}</p>
                                                ) : (
                                                    <>
                                                        {circumference !== '' && (
                                                            <>
                                                                <p className='p-3 mb-2 bg-success text-white'>
                                                                    Cylinder Circumference: {circumference}
                                                                </p>
                                                                <div className='p-3 mb-2 bg-info'>
                                                                    <b>Solution Steps</b>
                                                                    <ol>
                                                                        {solutionSteps.map((step, index) => (
                                                                            <li key={index}>{step}</li>
                                                                        ))}
                                                                    </ol>
                                                                </div>
                                                            </>
                                                        )}
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <hr />
                                <div className="row">
                                    <RelatedLinks />
                                    <hr />
                                </div>
                            </div>
                </div>
                <div className="col">
                    <SecondAds />
                    <br />
                    <MainCalculatorsList CalculatorsTypeId={CalculatorsType.mathCalculators}></MainCalculatorsList>
                    <br />
                </div>
            </div>
             <br />
        </div>
    );
}
export default Calculator;
